import { queryParametersFromString } from '@shared/lib/utils/create-query-parameters/query-parameters-from-string';
import { queryParametersToString } from '@shared/lib/utils/query-parameters-to-string/query-parameters-to-string';
import { useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { UseUrlTabs } from './types';

/* 
    Позволяет сохранять выбранный таб в URL 
    Использует хранение значения таба с помощью search параметров
    Пример: /some-url?searchUrlKey=tab-1
    searchUrlKey - ключ, который будет использован в url страницы
*/

export const useUrlTabs: UseUrlTabs = ({ searchUrlKey = 'tab', tabValues, initialTabValue }) => {
    const location = useLocation();
    const history = useHistory();

    const tabValueFromUrl = useMemo(() => {
        const parameters = queryParametersFromString(location.search);
        const urlTabValue = parameters[searchUrlKey];
        return tabValues.includes(urlTabValue) ? urlTabValue : undefined;
    }, [location.search, tabValues, searchUrlKey]);

    const [tabValue, setTabValue] = useState(tabValueFromUrl || initialTabValue);

    const handleSetTabValue = (tabValue: string) => {
        setTabValue(tabValue);
        history.replace({ search: queryParametersToString({ [searchUrlKey]: tabValue }) });
    };

    return {
        tabValue,
        handleSetTabValue,
    };
};
